// extracted by mini-css-extract-plugin
export default {"agora-input-error":"agora-input-error_agora-input-error__EsqlS"};